import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// PayPal JS SDK (zoid) throws a benign error when its buttons unmount on navigation
window.addEventListener("error", (e) => {
  if (e.message?.includes("zoid destroyed all components")) e.preventDefault();
});
window.addEventListener("unhandledrejection", (e) => {
  if (String(e.reason?.message || e.reason || "").includes("zoid destroyed all components")) e.preventDefault();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
